import { escapeHtml } from "../utils/escapeHtml";

interface AuditDisplayEntry {
  timestamp: string;
  user: string;
  action: string;
  targetType: string;
  targetId: string;
  details: string;
}

export function renderAuditLog(container: HTMLElement, entries: AuditDisplayEntry[]): void {
  if (!entries.length) {
    container.innerHTML = `<p class="empty-state"><span class="empty-state-message">No activity recorded yet.</span></p>`;
    return;
  }

  container.innerHTML = `
    <div class="audit-timeline">
      ${entries.slice(0, 50).map((e) => {
        const date = e.timestamp ? new Date(e.timestamp).toLocaleString() : "—";
        return `<div class="audit-entry">
          <div class="audit-entry-dot"></div>
          <div class="audit-entry-content">
            <div class="audit-entry-header">
              <span class="audit-entry-action">${escapeHtml(e.action)}</span>
              <span class="audit-entry-time">${escapeHtml(date)}</span>
            </div>
            <div class="audit-entry-detail">${escapeHtml(e.targetType)} ${escapeHtml(e.targetId)}${e.details ? " — " + escapeHtml(e.details) : ""}</div>
            <div class="audit-entry-user">${escapeHtml(e.user)}</div>
          </div>
        </div>`;
      }).join("")}
    </div>
  `;
}
